import { AppColors } from "./constants/ColorsConstants";

export const getAppColor = seed => {
  const x = seed.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return AppColors[Math.abs((x % AppColors.length) - 1)];
};
